var map = {
	"./About.vue": [
		"f820",
		"chunk-764b959c"
	],
	"./Gallery.vue": [
		"0d77"
	],
	"./Main.vue": [
		"cd56"
	],
	"./Messages.vue": [
		"eaad"
	],
	"./Quiz.vue": [
		"2e44",
		"chunk-1d987e22"
	],
	"./QuizEN.vue": [
		"607e",
		"chunk-4996711e"
	],
	"./QuizJP.vue": [
		"75b6",
		"chunk-26023c01"
	],
	"./QuizZH.vue": [
		"9463",
		"chunk-327d254c"
	],
	"./Results.vue": [
		"b3c3",
		"chunk-2d20f8f7"
	],
	"./Soundboard.vue": [
		"0c66",
		"chunk-07a6a04a"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;